import { EIPClient } from '@automation-suite/shared-clients-eip';
import { widgetFetchHttpClient } from '@automation-suite/shared-clients-widget-fetch-http';
import { eipApiKeyAuthClient } from '@automation-suite/widget-loader-clients-eip-api-key-auth';

export const eipClient: EIPClient = new EIPClient({
  apiKeyAuthClient: eipApiKeyAuthClient,
  baseUrl: process.env.NX_PUBLIC_EIP_URL,
  httpClient: widgetFetchHttpClient,
});
